export default "__VITE_ASSET__BSUaZqsT__"